"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoWidget = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    logo: {
      padding: 0
    }
  };
});

var LogoWidget = function LogoWidget(props) {
  var logo = props.logo,
      onClick = props.onClick,
      hidden = props.hidden,
      className = props.className,
      hide = props.hide;
  var classes = useStyles();

  if (hide) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_Hidden.default, hidden, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _classnames.default)(classes.logo, className),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      maxHeight: 40
    },
    src: logo,
    alt: "logo"
  })));
};

exports.LogoWidget = LogoWidget;
LogoWidget.propTypes = {
  /** Url da imagem a ser exibida */
  logo: _propTypes.default.string.isRequired,

  /** Callback que sera exexcutado ao clicar no logo */
  onClick: _propTypes.default.func.isRequired,

  /** Flag de curto-circuito para esconder o widget */
  hide: _propTypes.default.bool,

  /**
   * Propriedades para controlar quando esconder um objeto usa a mesma api do Componente do MUI Hidden
   * {@link https://v4.mui.com/components/hidden/#hidden [Detalhes]}
   */
  hidden: _propTypes.default.shape({
    lgDown: _propTypes.default.bool,
    lgUp: _propTypes.default.bool,
    mdDown: _propTypes.default.bool,
    mdUp: _propTypes.default.bool,
    only: _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])),
    smDown: _propTypes.default.bool,
    smUp: _propTypes.default.bool,
    xlDown: _propTypes.default.bool,
    xlUp: _propTypes.default.bool,
    xsDown: _propTypes.default.bool,
    xsUp: _propTypes.default.bool
  }),

  /** className usado para customizar o componente */
  className: _propTypes.default.string
};
LogoWidget.defaultProps = {
  hide: false,
  hidden: {
    lgDown: false,
    lgUp: false,
    mdDown: false,
    mdUp: false,
    only: null,
    smDown: false,
    smUp: false,
    xlDown: false,
    xlUp: false,
    xsDown: false,
    xsUp: false
  },
  className: ''
};